module.exports = __webpack_public_path__ + "img/23.0ba44119.jpg";